export const installedToast = {
  title: '此追踪工具已被安装',
  description: '请增加其他追踪工具或编辑此追踪工具',
};
